export function getBulkSmsPayload(response) {
  const backendResponse = response?.data || {};
  const bulkData = backendResponse.data || {};
  const successCount = bulkData.successCount || 0;
  const skipCount = bulkData.skipCount || 0;
  const failCount = bulkData.failCount || 0;
  return {
    ok: !!(response && response.success && backendResponse.success !== false),
    error: response?.error || backendResponse.error || backendResponse.message,
    successCount,
    skipCount,
    failCount,
    total: bulkData.total || successCount + skipCount + failCount,
    skipped: bulkData.skipped || [],
    failed: bulkData.failed || [],
  };
}

export function toastBulkSmsResult(toast, payload) {
  const { ok, error, successCount, skipCount, failCount } = payload;
  if (successCount > 0) {
    toast.success(
      skipCount
        ? `Sent ${successCount} message(s). ${skipCount} invalid or unsubscribed number(s) skipped.`
        : `Successfully sent ${successCount} message(s)!`,
      { duration: skipCount ? 6000 : 4000 }
    );
    return;
  }
  if (skipCount > 0 && failCount === 0) {
    toast(`No messages sent. ${skipCount} number(s) were invalid or unsubscribed.`, { duration: 6000 });
    return;
  }
  if (!ok || failCount > 0) {
    toast.error(error || 'Failed to send messages');
  }
}

export function isSingleSmsSkipped(response) {
  const body = response?.data || {};
  return !!(body.skipped || body.data?.skipped);
}
